import React, { useState, useContext, useEffect, useCallback } from 'react'
import ProductFieldsView from '@/custom/components/product/FieldsView'
import { dateTimeFormatFunction } from '@/product/common/components'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import * as Yup from 'yup'
import Layout from '@/product/components/templates/Layout'
import { useHistory } from 'react-router-dom'
import SettingContext from '@/product/context/setting/settingContext'
import CustomCommonContext from '@/custom/context/common/commonContext'
import { debounce } from 'lodash'

const DynamicListing = (props) => {
    const dynamicContext = useContext(DynamicContext)

    const { project_dynamicfields } = dynamicContext
    const settingcontext = useContext(SettingContext)
    const { searchJustGivingCharity, charityDetails } =
        useContext(CustomCommonContext)

    const {
        searchTableAction,
        updateConfigColumn,
        searchTableFetch,
        search_fetch_data,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseCommuncation,
    } = settingcontext
    const history = useHistory()

    const [updatedValues, setUpdatedValues] = useState({})
    const [asinMapData, setAsinMapData] = useState([])
    const [optionData, setOptionData] = useState([])
    const [homeMapData, setHomeMapData] = useState([])
    const [data, setData] = useState({
        popup: false,
        status: 'newTemplate',
        id: 0,
        projectType: 0,
    })

    useEffect(() => {
        if (props?.match?.params?.id && props?.match?.params?.status) {
            setData({
                popup: true,
                status: props?.match?.params?.status,
                id: props?.match?.params?.id,
                projectType: 0,
            })
        }
    }, [props?.match?.params?.id, props?.match?.params?.status])

    const [fieldValue, setFieldValue] = useState([])

    const debouncedChange = useCallback(
        debounce((newValue) => {
            searchJustGivingCharity(
                {
                    page: 1,
                    limit: 100,
                    order: '',
                    orderby: '',
                    count: 1,
                    filters: {
                        user_id: {
                            value: newValue,
                            type: 'like',
                            field: 'ci.fundraiser_name,ci.fundraiser_id,ci.reg_number',
                        },
                        country_code: {
                            value: 'GB',
                            type: 'in',
                            field: 'ci.country_code',
                        },
                    },
                    table: 'charity_info',
                },
                'charity_data'
            )
        }, 500),
        []
    )

    const optionFunc = (data) => {
        debouncedChange(data)
    }

    const custom = {
        charity_id: '',
        group_carts: '',
        charity_name: '',
        desc_proc: '',
    }

    useEffect(() => {
        if (project_dynamicfields && project_dynamicfields.length) {
            let projectDynamicArray = [
                ...project_dynamicfields,
                // {
                //     id: 47,
                //     label: 'Featured',
                //     name: 'featured',
                //     placeholder: 'featured',
                //     type: 'checkbox',
                //     searchtype: 'checkbox',
                //     view_page: 1,
                //     show_order: 1,
                //     active: 1,
                //     view_on: '',
                //     ClassName: 'col-6 ',
                //     class: 'col-6',
                // },
                {
                    id: 47,
                    label: 'Order Feature',
                    name: 'order_feature',
                    placeholder: 'Enter order number',
                    view_page: 1,
                    show_order: 1,
                    type: 'number',
                    active: 1,
                    view_on: '',
                    ClassName: 'col-sm-6 col-6',
                    class: 'col-sm-6 col-6',
                },
            ]
            let dynamicValueAssign = []
            let projectType = props?.data?.projectType

            projectDynamicArray
                .filter((data) => data.active === 1)
                .map((item) => {
                    if (item.view_on && projectType) {
                        if (
                            item.view_on.includes(projectType) ||
                            item.view_on.includes('10')
                        ) {
                            if (item.name === 'qty') {
                                item.initialDefault = 1
                            } else if (item.name === 'sprice') {
                                item.initialDefault = 0
                            } else if (item.name === 'rprice') {
                                item.initialDefault = 0
                            } else if (item.type == 'uploadDropZone') {
                                item.isCrop = true
                                item.multiple = false
                            } else if (item.name === 'charity_id') {
                                item.type = 'searchdrop'
                                item.style = { height: 30 }
                                item.getAllOptions = optionFunc
                                item.options = []
                                item.forcePopupIcon = false
                                item.focused = true
                            } else if (item.name == 'date_added') {
                                var today = new Date()

                                if (props?.data?.status !== 'edit') {
                                    item.initialDefault =
                                        dateTimeFormatFunction(today)
                                }
                            } else if (item.name == 'date_closed') {
                                var future = new Date()
                                if (props?.data?.status !== 'edit') {
                                    future.setDate(future.getDate() + 10)
                                    item.initialDefault =
                                        dateTimeFormatFunction(future)
                                }
                            }
                            if (item.name === 'desc_proc') {
                                item.config = {
                                    htmlSupport: {
                                        allow: [
                                            {
                                                name: /.*/,
                                                attributes: true,
                                                classes: true,
                                                styles: true,
                                            },
                                        ],
                                    },
                                    toolbar: [
                                        'heading',
                                        '|',
                                        'bold',
                                        'italic',
                                        'link',
                                        'bulletedList',
                                        'numberedList',
                                        '|',
                                        'indent',
                                        'outdent',
                                        '|',
                                        'blockquote',
                                        'mediaEmbed',
                                        'undo',
                                        'redo',
                                    ],
                                }
                            }
                            dynamicValueAssign.push(item)
                        }
                    } else {
                        if (item.name === 'qty') {
                            item.initialDefault = 1
                        } else if (item.name == 'date_added') {
                            var today = new Date()
                            if (props?.data?.status !== 'edit') {
                                item.initialDefault =
                                    dateTimeFormatFunction(today)
                            }
                        } else if (item.name == 'date_closed') {
                            var future = new Date()
                            if (props?.data?.status !== 'edit') {
                                future.setDate(future.getDate() + 10)
                                item.initialDefault =
                                    dateTimeFormatFunction(future)
                            }
                        } else if (item.name === 'sprice') {
                            item.initialDefault = 0
                        } else if (item.name === 'rprice') {
                            item.initialDefault = 0
                        } else if (item.type == 'uploadDropZone') {
                            item.isCrop = true
                            item.multiple = false
                        } else if (item.name === 'charity_id') {
                            item.type = 'searchdrop'
                            item.style = { height: 30 }
                            item.getAllOptions = optionFunc
                            item.forcePopupIcon = false
                            item.focused = true
                            item.class = 'col-sm-3 col-3 mt-1'
                            item.options = []
                        }
                        if (item.name === 'desc_proc') {
                            item.config = {
                                htmlSupport: {
                                    allow: [
                                        {
                                            name: /.*/,
                                            attributes: true,
                                            classes: true,
                                            styles: true,
                                        },
                                    ],
                                },
                                toolbar: [
                                    'heading',
                                    '|',
                                    'bold',
                                    'italic',
                                    'link',
                                    'bulletedList',
                                    'numberedList',
                                    '|',
                                    'indent',
                                    'outdent',
                                    '|',
                                    'blockquote',
                                    'mediaEmbed',
                                    'undo',
                                    'redo',
                                ],
                            }
                        }
                        dynamicValueAssign.push(item)
                    }
                })
            dynamicValueAssign.push(
                {
                    name: 'market_status',
                    value: 'draft',
                    type: 'default',
                    active: 1,
                },
                {
                    name: 'auctiontype',
                    value: 'live',
                    type: 'default',
                    active: 1,
                }
            )

            let dynamicQtyfilter = dynamicValueAssign.filter(
                (item) => item.label !== 'Quantity'
            )
            setFieldValue(dynamicQtyfilter)
        }
    }, [project_dynamicfields, props.data])

    const additionalFieldUpdate = (data) => {
        setUpdatedValues(data)
    }
    const closeFunction = () => {
        history.goBack()
    }
    return (
        <>
            {props?.standalone ? (
                <ProductFieldsView
                    fieldValue={fieldValue}
                    userId={props.userId}
                    data={props.data}
                    showasin={true}
                    homeDepot={true}
                    function={props.function}
                    asinMapData={asinMapData}
                    homeMapData={homeMapData}
                    draftValidation={true}
                    additionalFieldUpdate={additionalFieldUpdate}
                    closeFunction={closeFunction}
                    customFilter={props.customFilter}
                    standalone={true}
                    noSubmitBtn={false}
                    customInitialValues={custom}
                    edit={props.edit}
                />
            ) : (
                <Layout>
                    <ProductFieldsView
                        fieldValue={fieldValue}
                        userId={props.userId}
                        data={props.data}
                        showasin={true}
                        homeDepot={true}
                        function={props.function}
                        asinMapData={asinMapData}
                        homeMapData={homeMapData}
                        draftValidation={true}
                        additionalFieldUpdate={additionalFieldUpdate}
                        closeFunction={closeFunction}
                        customFilter={props.customFilter}
                        standalone={true}
                        noSubmitBtn={false}
                        customInitialValues={custom}
                        edit={props.edit}
                    />
                </Layout>
            )}
        </>
    )
}

export default DynamicListing
